import "./css/main.scss";
// 导入 Swiper 样式
import 'swiper/css/swiper.min.css';

// 导入交互脚本
import './page/menu.js';

// 导入画廊轮播图
import './page/gallery-slider.js';

// 导航高亮
import './utils/nav-highlight.js';

// 页脚年份更新
import './utils/footer-year.js';

// 捐款折叠组件
import './page/accordion.js';

// 复制链接按钮交互
import './page/copy-link.js';

// 全站搜索功能 (Vue 组件)
import './page/search-panel.js';

// PDF 查看器
import './page/pdf-viewer.js';

